import React from 'react';
import { motion } from 'framer-motion';

const MentionsLegalesPage = () => {
    return (
        <div className="min-h-screen bg-gray-900 text-white">
            <div className="container mx-auto px-4 py-4 md:py-8 lg:py-12">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="container mx-auto px-4 py-8 md:py-12 lg:py-16 bg-gray-900 text-white"
                >
                    <h1 className="text-3xl font-bold text-center mb-8 text-white">Mentions Légales</h1>
                    <br /><br />
                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">1. Informations légales</h2>
                        <div className="space-y-2">
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Propriétaire du site :</span> Sev Remorque
                            </p>
                            <p className="text-gray-300 ml-4">
                                Forme juridique : Micro-entreprise.
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Adresse postale :</span> 66000 PERPIGNAN, 41 Rue des oiseaux
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Numéro de téléphone :</span> 06.99.46.31.59
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Adresse de courrier électronique :</span> severincortes7@gmail.com
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Numéro SIRET :</span> 83111054900027
                            </p>
                            <p className="text-gray-300 ml-4">
                                Numéro RCS : 831110549
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Responsable de la publication :</span> Severin Cortes
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Hébergeur du site :</span> OVHCloud
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Adresse postale de l'hébergeur :</span> 2, rue Kellermann, 59100 Roubaix.
                            </p>
                            <p className="text-gray-300">
                                <span className="font-semibold text-white">Numéro de téléphone de l'hébergeur :</span> 1007 (appel France) ou au 09 72 10 10 07 (appel de l'étranger) du lundi au vendredi de 8h à 18h.
                            </p>
                        </div>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">2. Conditions générales d'utilisation</h2>
                        <p className="text-gray-300">
                            L'utilisation du site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> implique l'acceptation pleine et entière des conditions
                            générales d'utilisation ci-après décrites. Ces conditions d'utilisation sont susceptibles d'être modifiées
                            ou complétées à tout moment, les utilisateurs du site sont donc invités à les consulter de manière régulière.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">3. Description des services fournis</h2>
                        <p className="text-gray-300">
                            Le site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> a pour objet de fournir une information concernant l'ensemble des activités
                            de la société. Sev Remorque s'efforce de fournir sur le site des informations aussi
                            précises que possible. Toutefois, il ne pourra être tenu responsable des omissions, des inexactitudes et
                            des carences dans la mise à jour, qu'elles soient de son fait ou du fait des tiers partenaires qui lui
                            fournissent ces informations.
                        </p>
                        <p className="text-gray-300">
                            Les informations indiquées sur le site sont données à titre indicatif, et sont susceptibles d'évoluer.
                            Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs. Ils sont donnés sous réserve
                            de modifications ayant été apportées depuis leur mise en ligne.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">4. Limitations contractuelles sur les données techniques</h2>
                        <p className="text-gray-300">Le site utilise la technologie JavaScript.</p>
                        <p className="text-gray-300">
                            Le site Internet ne pourra être tenu responsable des dommages matériels liés à l'utilisation du site. De plus, l'utilisateur du site s'engage à accéder au site en utilisant un matériel récent, ne contenant pas de virus et avec un navigateur de dernière génération mis-à-jour.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">5. Propriété intellectuelle</h2>
                        <p className="text-gray-300">
                            Tous les éléments du site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a>, incluant les textes, images, logos, icônes, sons,
                            logiciels, sont protégés par le droit d'auteur, le droit des marques ou le droit des brevets. Toute
                            reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du
                            site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de :
                            Sev Remorque.
                        </p>
                        <p className="text-gray-300">
                            Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient sera
                            considérée comme constitutive d'une contrefaçon et poursuivie conformément aux dispositions des articles
                            L.335-2 et suivants du Code de la Propriété Intellectuelle.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">6. Liens hypertextes</h2>
                        <p className="text-gray-300">
                            Le site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> peut contenir des liens hypertextes vers d'autres sites internet.
                            Sev Remorque n'a pas la possibilité de vérifier le contenu des sites ainsi visités,
                            et n'assumera en conséquence aucune responsabilité de ce fait.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">7. Gestion des données personnelles</h2>
                        <p className="text-gray-300">
                            En France, les données personnelles sont notamment protégées par la loi n° 78-87 du 6 janvier 1978, la loi
                            n° 2004-801 du 6 août 2004 relative à la protection des personnes physiques à l'égard des traitements
                            de données à caractère personnel et le Règlement Général sur la Protection des Données (RGPD).
                        </p>
                        <p className="text-gray-300">
                            À l'occasion de l'utilisation du site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a>, peuvent être recueillies : l'URL des liens
                            par l'intermédiaire desquels l'utilisateur a accédé au site, le fournisseur d'accès de l'utilisateur,
                            l'adresse de protocole Internet (IP) de l'utilisateur.
                        </p>
                        <p className="text-gray-300">
                            Sont seules collectées les informations relatives à l'utilisateur pour le besoin des services proposés
                            par le site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a>. L'utilisateur fournit ces informations en toute connaissance de
                            cause, notamment lorsqu'il procède par lui-même à leur saisie. Il est alors précisé à l'utilisateur du
                            site l'obligation ou non de fournir ces informations.
                        </p>
                        <p className="text-gray-300">
                            Conformément aux dispositions des articles 38 et suivants de la loi 78-17 du 6 janvier 1978 relative à
                            l'informatique, aux fichiers et aux libertés, tout utilisateur dispose d'un droit d'accès, de
                            rectification et d'opposition aux données personnelles le concernant, en effectuant sa demande écrite
                            et signée, accompagnée d'une copie du titre d'identité avec signature du titulaire de la pièce, en
                            précisant l'adresse à laquelle la réponse doit être envoyée.
                        </p>
                        <p className="text-gray-300">
                            Aucune information personnelle de l'utilisateur du site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> n'est publiée à l'insu
                            de l'utilisateur, échangée, transférée, cédée ou vendue sur un support quelconque à des tiers. Seule
                            l'hypothèse du rachat de Sev Remorque et de ses droits permettrait la
                            transmission des dites informations à l'éventuel acquéreur qui serait à son tour tenu de la même
                            obligation de conservation et de modification des données vis à vis de l'utilisateur du site
                            <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a>.
                        </p>
                        <p className="text-gray-300">
                            Les bases de données sont protégées par les dispositions de la loi du 1er juillet 1998 transposant
                            la directive 96/9/CE du 11 mars 1996 relative à la protection juridique des bases de données.
                        </p>
                    </section>

                    <section className="mb-8 space-y-4">
                        <h2 className="text-2xl font-semibold text-yellow-400">8. Droit applicable et attribution de juridiction</h2>
                        <p className="text-gray-300">
                            Tout litige en relation avec l'utilisation du site <a 
                                href="https://www.dépannage-occitanie.com"
                                className="text-1xl font-semibold text-yellow-200"
                            >
                                https://www.dépannage-occitanie.com
                            </a> est soumis au droit français.
                            Il est fait attribution exclusive de juridiction aux tribunaux compétents de Perpignan.
                        </p>
                    </section>
                </motion.div>
            </div>
        </div>
    );
};

export default MentionsLegalesPage;